export class InternalError extends Error {
  readonly name: string

  readonly __proto__: InternalError

  constructor(message = "Internal Error") {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "INTERNAL_ERROR"
  }
}
